/* eslint-disable no-unused-expressions */
/* eslint-disable import/no-extraneous-dependencies */
import React, {useEffect, useRef, useState} from 'react';
import {useRouter} from 'next/router';
import {Typography} from '../../typography';
import {Box, AnimatedBox} from '../../box';
import {FrameworkImage} from '../../image-renderer';
import {Pressable} from '../../pressable';
import {ArrowRightSolidIcon} from '../../icons';
import {useSpring} from '../../animation';

export type FeatureArtistCardProps = {
  artist: string;
  src: string;
  isMobile: boolean;
  onPress: () => void;
  hasBorder?: boolean;
};

export const FeatureArtistCard: React.FC<FeatureArtistCardProps> = ({
  artist,
  src,
  onPress,
  isMobile,
  hasBorder,
}) => {
  const [isHovered, setIsHovered] = useState(true);

  const heightAnimation = useSpring({
    height: isHovered || isMobile || true ? '48px' : '5px',
    paddingTop: isHovered || isMobile || true ? '16px' : '0px',
    bottom: isHovered || isMobile || true ? '0px' : '-15px',
    paddingLeft: '16px',
    config: {
      duration: 300,
    },
    delay: 500,
  });

  const moveAnimation = useSpring({
    opacity: isHovered || isMobile || true ? 1 : 0,
    height: isHovered || isMobile || true ? 'unset' : '0px',
    bottom: isHovered || isMobile || true ? '13px' : '-15px',
    left: '16px',
    config: {
      duration: 300,
    },
  });

  const hoveredStyle = useSpring({
    opacity: isHovered ? 1 : 0.84,
  });

  const nftCard = () => {
    return (
      <FrameworkImage
        src={src}
        alt={src}
        width={377}
        height={377}
        objectFit="cover"
      />
    );
  };

  return (
    <Pressable
      onPress={onPress}
      onHoverIn={() => setIsHovered(true)}
      onHoverOut={() => setIsHovered(false)}
    >
      <AnimatedBox
        width="100%"
        overflow="hidden"
        position="relative"
        borderStyle="solid"
        borderWidth={hasBorder ? 'two' : 'zero'}
        borderColor="gray"
        style={{...hoveredStyle}}
      >
        <AnimatedBox
          style={
            {
              ...heightAnimation,
              zIndex: 2,
              width: '100%',
              position: 'absolute',
              background: 'var(--ttx-colors-surfaceDark)',
              borderTopStyle: 'solid',
              borderTopWidth: '1px',
              borderTopColor: '#fff',
            } as any
          }
          background="surfaceDark"
          overflow="hidden"
        />
        <AnimatedBox
          style={{...moveAnimation, position: 'absolute', zIndex: 3}}
        >
          <Typography
            fontSize="xm"
            whiteSpace="nowrap"
            style={{color: 'var(--studio-secondaryText)'}}
          >
            {artist || ' '}
          </Typography>
        </AnimatedBox>
        <Box
          borderBottomStyle="solid"
          borderWidth="one"
          borderColor="outlines"
          style={{zIndex: 1}}
        >
          {src ? nftCard() : null}
        </Box>
      </AnimatedBox>
    </Pressable>
  );
};
